'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$0024eq$0024colon$0024eq from "./scala.$eq$colon$eq.js";
var $p;
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
export { $c_s_$less$colon$less$$anon$1 as $c_s_$less$colon$less$$anon$1 };
$p = $c_s_$less$colon$less$$anon$1.prototype = new $j_scala$002e$0024eq$0024colon$0024eq.$h_s_$eq$colon$eq();
$p.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
export { $h_s_$less$colon$less$$anon$1 as $h_s_$less$colon$less$$anon$1 };
$h_s_$less$colon$less$$anon$1.prototype = $p;
$p.j = (function(x) {
  return x;
});
$p.b = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  rq: 1,
  rn: 1,
  ro: 1,
  o: 1,
  a: 1
}));
export { $d_s_$less$colon$less$$anon$1 as $d_s_$less$colon$less$$anon$1 };
